import React from "react"
import { useTheme } from "@mui/material"
import type { PaymentPresentation } from "@/domain/order/order-details-payment-presentation"
import { PaymentInlineIndicator, type PaymentInlineIndicatorSize } from "@/components/order/PaymentInlineIndicator"
import { resolvePaymentStatusIndicatorPresentation } from "@/components/order/payment-status-presentation"

export type PaymentStatusIndicatorProps = {
  presentation: Pick<PaymentPresentation, "statusLabel" | "statusVariant">
  size?: PaymentInlineIndicatorSize
}

export function PaymentStatusIndicator({ presentation, size = "default" }: PaymentStatusIndicatorProps) {
  const theme = useTheme()
  const { label, Icon, accentColor } = resolvePaymentStatusIndicatorPresentation(presentation, theme)

  return (
    <PaymentInlineIndicator
      className="payment-status-indicator"
      label={label}
      Icon={Icon}
      accentColor={accentColor}
      ariaLabel={`Payment status: ${label}`}
      size={size}
    />
  )
}

export default PaymentStatusIndicator
